import { computed, reactive } from 'vue'
import type { IConfigApp } from '@/config/config-app-models'

export const E4sThemes = ['def', 'irl', 'gbr'] as const
export type E4sTheme = (typeof E4sThemes)[number]

export type E4sThemeId = '' | 'ia'

export const E4sCssThemeIds: Record<E4sTheme, E4sThemeId> = {
  def: '',
  irl: 'ia',
  gbr: ''
}

export interface IConfigStoreState {
  configApp: IConfigApp
}

const configStore = reactive<IConfigStoreState>({
  configApp: {
    theme: 'def'
  } as IConfigApp
})

/**
 *
 */
export function useConfigController() {
  const getCssEnvIdentifier = computed<E4sThemeId>(() => {
    return E4sCssThemeIds[configStore.configApp.theme]
  })

  //  TODO...this is not returning correct type
  const getCssEnvSuffix = computed<string>(() => {
    // const doesValueExistForEnv = E4sCssThemeIds[configStore.configApp.theme];
    //
    // return doesValueExistForEnv === "" ? "" : doesValueExistForEnv + "-";
    return ''
  })

  return {
    getCssEnvIdentifier,
    getCssEnvSuffix
  }
}
